import { Link, useNavigate } from '@tanstack/react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { PartCreateInput, PartImageInput } from '@ncc/shared';
import { PartForm, type PartFormValues } from '../components/PartForm';
import { api } from '../lib/api';

export function NewPart() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const finalize = useMutation({
    mutationFn: async ({
      values,
      images,
    }: {
      values: PartFormValues;
      images: PartImageInput[];
    }) => {
      const payload = { ...values, images } as PartCreateInput;
      return api.createPart(payload);
    },
    onSuccess: (created) => {
      queryClient.invalidateQueries({ queryKey: ['parts'] });
      navigate({ to: '/parts/edit/$id', params: { id: String(created.id) } });
    },
  });

  return (
    <>
      <header className="toolbar">
        <h2 style={{ margin: 0 }}>New Part</h2>
        <span className="grow" />
        <Link to="/parts">
          <button className="ghost">Cancel</button>
        </Link>
      </header>

      <div className="card">
        <PartForm
          submitLabel="Create part"
          onSubmit={async (values, images) => {
            await finalize.mutateAsync({ values, images });
          }}
        />
      </div>

      {finalize.isError ? (
        <div className="toast">Create failed: {String(finalize.error)}</div>
      ) : null}
    </>
  );
}
